module.exports = __webpack_public_path__ + "static/john-digweed-eb96021f98af9753f603d7c3df66297a.png";